<template>
    <div class="block-partners" :style="getBlockPartnersStyle">
        <div class="container">
            <div class="block-partners__content">
                <z-caption class="block-partners__title" tag="h2" size="lt">{{ title }}</z-caption>
                <div class="row">
                    <div
                        v-for="(item, index) in detail?.partners" :key="index"
                        class="col-default-6 col-v-tablet-12"
                    >
                        <div class="block-partners__block">
                            <div class="u-flex u-gap--xs u-align-center u-bottom-margin--s">
                                <z-image
                                  :src="item.previewPicture?.link"
                                  :alt="item.name"
                                  class="block-partners__image"
                                />
                                <z-caption tag="h4" weight="500" size="xl">{{ item.name }}</z-caption>
                            </div>
                            <p class="block-partners__text" >
                                <vue-raw :raw="item.previewText"></vue-raw>
                            </p>
                        </div>
                    </div>
                </div>
                <z-button
                    tag="a"
                    :href="`/career/youth-programs/project-partners/?program=${detail.id}`"
                    kind="bordered"
                    border-radius
                    size="l"
                    class="u-top-margin--l"
                >
                    Стать партнером проекта
                    <template #right>
                        <z-icon name="arrows/round-arrow-big" dir="right"></z-icon>
                    </template>
                </z-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import ZImage from "../ZImage/ZImage";

const props = defineProps({
    detail: {
        type: Object
    },
    title: {
        type: String,
        default: 'Партнеры проекта'
    },
    bgImage: {
        type: String,
        default: '/media/img/bg-partners.png'
    },
})

const getBlockPartnersStyle = computed(() => {
    return `background-image: url('${props.bgImage}')`
})

</script>

<style lang="scss">
.block-partners {
    padding: var(--spacer-3xl) 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-size: cover;
    background-repeat: no-repeat;

    &__block {
        height: 100%;
        padding: var(--spacer-m);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.20) 100%), rgba(255, 255, 255, 0.20);
        border-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.20);

        @include breakpoint(v-tablet) {
            width: 100%;
        }

        .z-caption {
            margin-bottom: 0;
        }
    }

    // &__cards {
    //     @include breakpoint(v-tablet) {
    //         flex-direction: column;
    //     }
    // }

    &__image {
        max-width: 120px;
        max-height: 120px;

        @include breakpoint(v-tablet) {
            max-width: 90px;
            max-height: 90px;
        }
    }

    &__text {
        font-size: var(--typography-l);
    }

    h2, h3, h4, p {
        color: var(--color-white);
    }

}
</style>
